import * as lendiaConfig from "./CustomThemeLendia";
import * as finbeConfig from "./CustomThemeFinbe";
import * as finbraConfig from "./CustomThemeFinbra";
import * as nowPortsConfig from "./CustomThemeNowPorts";
import * as marketPlaceConfig from "./CustomThemeMarketPlace";
import * as avanzaSolidoConfig from "./CustomThemeAvanzaSolido";
import * as kapitalFlexConfig from "./CustomThemeKapitalFlex";
import * as providenciConfig from "./CustomThemeProvidencia";
import * as kalapataConfig from "./CustomThemeKalapata";
import * as casofinConfig from "./CustomThemeCasofin";
import * as sfiConfig from "./CustomThemeSFI";
import * as afirmeConfig from "./CustomThemeAfirme";
import * as santanderConfig from "./CustomThemeSantander";
import * as actinver from "./CustomThemeActinver";
import * as bbvaConfig from "./CustomThemeBbva";
import * as nafin from "./CustomThemeNafin";
import * as incredit from "./CustomThemeIncredit";
import * as arraCapitalConfig from "./CustomThemeArraCapital";
import * as lanitAutoConfig from "./CustomThemeLanitAuto";
import * as micredimoto from "./CustomThemeMiCredimoto";
import * as lendiaDemoConfig from "./CustomThemeLendiaDemo";

export const DEFAULT_THEME = finbeConfig;

export const THEMES = {
  lendia: lendiaConfig,
  finbe: finbeConfig,
  finbra: finbraConfig,
  now_ports: nowPortsConfig,
  market_place: marketPlaceConfig,
  avanza_solido: avanzaSolidoConfig,
  kapital_flex: kapitalFlexConfig,
  providencia: providenciConfig,
  kalapata: kalapataConfig,
  casofin: casofinConfig,
  sfi: sfiConfig,
  afirme: afirmeConfig,
  santander: santanderConfig,
  actinver,
  bbva: bbvaConfig,
  nafin,
  incredit,
  arra_capital: arraCapitalConfig,
  lanitauto: lanitAutoConfig,
  micredimoto,
  lendia_demo: lendiaDemoConfig,
};
